"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Line = exports.Footer = exports.Empty = exports.MarkAllAsRead = exports.Header = exports.MessageList = exports.MessageListContainer = exports.DismissInbox = exports.ResponsiveContainer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ResponsiveContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__ResponsiveContainer",
  componentId: "sc-1mijnn2-0"
})(function (_ref) {
  var theme = _ref.theme,
      isMobile = _ref.isMobile;
  return (0, _deepExtend["default"])(_objectSpread({}, isMobile ? {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh"
  } : {}), theme === null || theme === void 0 ? void 0 : theme.container);
});

exports.ResponsiveContainer = ResponsiveContainer;

var DismissInbox = _styledComponents["default"].button.withConfig({
  displayName: "styled__DismissInbox",
  componentId: "sc-1mijnn2-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return (0, _deepExtend["default"])({
    border: "none",
    borderRadius: "50%",
    position: "absolute",
    top: 6,
    right: 8,
    cursor: "pointer",
    width: 42,
    height: 42,
    background: "rgba(115, 129, 155, 0.6)",
    color: "white",
    transition: "background 100ms ease-in",
    "&:hover": {
      background: "rgba(115, 129, 155, 0.8)"
    }
  }, theme === null || theme === void 0 ? void 0 : theme.dismissInbox);
});

exports.DismissInbox = DismissInbox;

var MessageListContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__MessageListContainer",
  componentId: "sc-1mijnn2-2"
})(function (_ref3) {
  var _theme$brand, _theme$brand$inapp, _theme$brand$inapp$wi, _theme$brand2, _theme$brand2$inapp, _theme$brand2$inapp$w, _theme$brand3, _theme$brand3$inapp, _theme$brand3$inapp$w, _theme$brand4, _theme$brand4$inapp, _theme$brand4$inapp$w, _theme$brand$colors$s, _theme$brand5, _theme$brand5$colors;

  var theme = _ref3.theme;
  return (0, _deepExtend["default"])({
    background: (_theme$brand = theme.brand) !== null && _theme$brand !== void 0 && (_theme$brand$inapp = _theme$brand.inapp) !== null && _theme$brand$inapp !== void 0 && (_theme$brand$inapp$wi = _theme$brand$inapp.widgetBackground) !== null && _theme$brand$inapp$wi !== void 0 && _theme$brand$inapp$wi.topColor && (_theme$brand2 = theme.brand) !== null && _theme$brand2 !== void 0 && (_theme$brand2$inapp = _theme$brand2.inapp) !== null && _theme$brand2$inapp !== void 0 && (_theme$brand2$inapp$w = _theme$brand2$inapp.widgetBackground) !== null && _theme$brand2$inapp$w !== void 0 && _theme$brand2$inapp$w.bottomColor ? "linear-gradient(180deg, ".concat((_theme$brand3 = theme.brand) === null || _theme$brand3 === void 0 ? void 0 : (_theme$brand3$inapp = _theme$brand3.inapp) === null || _theme$brand3$inapp === void 0 ? void 0 : (_theme$brand3$inapp$w = _theme$brand3$inapp.widgetBackground) === null || _theme$brand3$inapp$w === void 0 ? void 0 : _theme$brand3$inapp$w.topColor, " 0%, ").concat((_theme$brand4 = theme.brand) === null || _theme$brand4 === void 0 ? void 0 : (_theme$brand4$inapp = _theme$brand4.inapp) === null || _theme$brand4$inapp === void 0 ? void 0 : (_theme$brand4$inapp$w = _theme$brand4$inapp.widgetBackground) === null || _theme$brand4$inapp$w === void 0 ? void 0 : _theme$brand4$inapp$w.bottomColor, " 100%)") : (_theme$brand$colors$s = (_theme$brand5 = theme.brand) === null || _theme$brand5 === void 0 ? void 0 : (_theme$brand5$colors = _theme$brand5.colors) === null || _theme$brand5$colors === void 0 ? void 0 : _theme$brand5$colors.secondary) !== null && _theme$brand$colors$s !== void 0 ? _theme$brand$colors$s : "#9121c2",
    padding: 17,
    paddingBottom: 0
  }, theme === null || theme === void 0 ? void 0 : theme.container);
});

exports.MessageListContainer = MessageListContainer;

var MessageList = _styledComponents["default"].div.withConfig({
  displayName: "styled__MessageList",
  componentId: "sc-1mijnn2-3"
})(function (_ref4) {
  var _theme$messageList;

  var isMobile = _ref4.isMobile,
      theme = _ref4.theme;
  var defaultHeight = 392;

  var height = function () {
    if (!isMobile) {
      return defaultHeight;
    }

    return "Calc(100vh - 205px)";
  }();

  return (0, _deepExtend["default"])({
    background: "rgba(255, 255, 255, 0.2)",
    overflow: "scroll",
    display: "flex",
    height: height,
    maxHeight: height,
    flexDirection: "column",
    borderTop: "1px solid rgba(203,213,224,.5)"
  }, theme === null || theme === void 0 ? void 0 : (_theme$messageList = theme.messageList) === null || _theme$messageList === void 0 ? void 0 : _theme$messageList.container);
});

exports.MessageList = MessageList;

var Header = _styledComponents["default"].div.withConfig({
  displayName: "styled__Header",
  componentId: "sc-1mijnn2-4"
})(function (_ref5) {
  var theme = _ref5.theme;
  return (0, _deepExtend["default"])({
    padding: "18px 20px 12px 20px",
    userSelect: "none",
    display: "flex",
    color: "#24324b",
    justifyContent: "space-between",
    fontSize: "18px",
    fontWeight: "700",
    lineHeight: "25px"
  }, theme === null || theme === void 0 ? void 0 : theme.header);
});

exports.Header = Header;

var MarkAllAsRead = _styledComponents["default"].a.withConfig({
  displayName: "styled__MarkAllAsRead",
  componentId: "sc-1mijnn2-5"
})(["font-size:14px;font-style:normal;font-weight:400;line-height:19px;letter-spacing:0em;color:#9121c2;"]);

exports.MarkAllAsRead = MarkAllAsRead;

var Empty = _styledComponents["default"].div.withConfig({
  displayName: "styled__Empty",
  componentId: "sc-1mijnn2-6"
})(function (_ref6) {
  var _theme$brand$inapp$em, _theme$brand6, _theme$brand6$inapp, _theme$brand6$inapp$e;

  var theme = _ref6.theme;
  return (0, _deepExtend["default"])({
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "25px",
    letterSpacing: "0em",
    textAlign: "center",
    color: (_theme$brand$inapp$em = theme === null || theme === void 0 ? void 0 : (_theme$brand6 = theme.brand) === null || _theme$brand6 === void 0 ? void 0 : (_theme$brand6$inapp = _theme$brand6.inapp) === null || _theme$brand6$inapp === void 0 ? void 0 : (_theme$brand6$inapp$e = _theme$brand6$inapp.emptyState) === null || _theme$brand6$inapp$e === void 0 ? void 0 : _theme$brand6$inapp$e.textColor) !== null && _theme$brand$inapp$em !== void 0 ? _theme$brand$inapp$em : "white",
    margin: "auto"
  }, theme === null || theme === void 0 ? void 0 : theme.emptyState);
});

exports.Empty = Empty;

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "styled__Footer",
  componentId: "sc-1mijnn2-7"
})(function (_ref7) {
  var theme = _ref7.theme;
  return (0, _deepExtend["default"])({
    alignItems: "center",
    background: "white",
    display: "flex",
    fontSize: "10px",
    fontStyle: "normal",
    letterSpacing: ".1rem",
    position: "relative",
    zIndex: 1,
    boxShadow: "0 14px 11px 18px #3445632e",
    fontWeight: "700",
    height: 45,
    justifyContent: "center",
    paddingRight: 18,
    svg: {
      marginTop: 2,
      marginLeft: -1
    },
    a: {
      display: "inherit",
      color: "#B9C0CD"
    }
  }, theme === null || theme === void 0 ? void 0 : theme.footer);
});

exports.Footer = Footer;

var Line = _styledComponents["default"].div.withConfig({
  displayName: "styled__Line",
  componentId: "sc-1mijnn2-8"
})(function (_ref8) {
  var _theme$brand$colors$p, _theme$brand7, _theme$brand7$colors;

  var theme = _ref8.theme;
  return {
    backgroundColor: (_theme$brand$colors$p = theme === null || theme === void 0 ? void 0 : (_theme$brand7 = theme.brand) === null || _theme$brand7 === void 0 ? void 0 : (_theme$brand7$colors = _theme$brand7.colors) === null || _theme$brand7$colors === void 0 ? void 0 : _theme$brand7$colors.primary) !== null && _theme$brand$colors$p !== void 0 ? _theme$brand$colors$p : "#9121c2",
    height: "4px",
    flex: 1,
    opacity: "0.18",
    ":first-child": {
      marginRight: "15px"
    },
    ":last-child": {
      marginLeft: "15px"
    }
  };
});

exports.Line = Line;